/**
 * AlmadarPostIkeaEffectSoftwareSLAlmadarPostIkeaEffectSoftwareSLPage
 *
 * Page component for AlmadarPostIkeaEffectSoftwareSLAlmadarPostIkeaEffectSoftwareSLPage
 * Path: /sl/blog/ikea-effect-software
 *
 * @generated from schema
 */

import React from 'react';
import { useLocation } from 'react-router-dom';
import type { EventPayload } from '@almadar/core';
import { AlmadarPostIkeaEffectSoftwareSLPostPageView as __AlmadarPostIkeaEffectSoftwareSLPostPageView } from '@/components/traits/AlmadarPostIkeaEffectSoftwareSLPostPageView';
import { AlmadarPostIkeaEffectSoftwareSLPostAnalyticsView as __AlmadarPostIkeaEffectSoftwareSLPostAnalyticsView } from '@/components/traits/AlmadarPostIkeaEffectSoftwareSLPostAnalyticsView';
import { VStack, UISlotComponent } from '@almadar/ui/components';

interface AlmadarPostIkeaEffectSoftwareSLAlmadarPostIkeaEffectSoftwareSLPageProps {
  // Add any page-level props here
}

export function AlmadarPostIkeaEffectSoftwareSLAlmadarPostIkeaEffectSoftwareSLPage(_props: AlmadarPostIkeaEffectSoftwareSLAlmadarPostIkeaEffectSoftwareSLPageProps) {
  const __navState = (useLocation().state ?? {}) as EventPayload;

  return (
    <>
      <UISlotComponent slot="main">
        <VStack gap="lg" className="w-full">
          <__AlmadarPostIkeaEffectSoftwareSLPostPageView config={{ initPayload: __navState }} />
          <__AlmadarPostIkeaEffectSoftwareSLPostAnalyticsView config={{ initPayload: __navState }} />
        </VStack>
      </UISlotComponent>
    </>
  );
}

export default AlmadarPostIkeaEffectSoftwareSLAlmadarPostIkeaEffectSoftwareSLPage;
